import { isExtensionInstalled } from "./actions";

export const state = {
  user: {},
  init: false,
  status: "",
  justRegistered: false,
  isExtensionInstalled:false,
  loading: false,
  cvs: [],
  uploadedCV: {
    cvId: 0,
    fileName: "",
  },
};
